import React, { Component } from 'react'
import MasterService from '../../services/MasterService';
import DealerProff from '../../webroot/images/dealer-proff.jpg'
import { toast } from 'react-toastify';
import {Calendra} from '../reconciliation/DatePicker'

class BankMatchRecordPopupList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      statementSearchText: '', // New state for statement search
      selectedBankRecordId: props.record?.bank_statement_match_id || null,
      loading: false,
      loading_delete: false,
      error: '',
      filterDate: '',
      statementList: [],
      slectedStatementItem: {},
      loadingStatement: false,
      showStatementList: false,
      selectedStatementIndex: null
    };
  }

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  }

  handleStatementSearchChange = (e) => {
    this.setState({ statementSearchText: e.target.value });
  }

  handleDateChange = (date) => {
    this.setState({ filterDate: date });
  }

  handleSelectStatement = (statement, index) => {
    this.setState({ selectedStatementIndex: index });
    this.setState({selectedBankRecordId: -1});
     this.setState({ slectedStatementItem: statement });

    console.log('Selected statement:', statement);
     console.log('index index:', index);
  }

  handleStatementListSearch = async () => {
    const { filterDate } = this.state;
    
    if (!filterDate) {
      toast.warning('Please select a date');
      return;
    }

    this.setState({ loadingStatement: true, error: '' });
    try {
      const response = await MasterService.getStatementList(filterDate);
      if (response && response?.data && response?.status==200) {
        this.setState({ 
          statementList: response.data,
          showStatementList: true,
          loadingStatement: false 
        });
        toast.success(`Statement list fetched successfully for ${filterDate}`);
      } else {
          this.setState({ 
          statementList: [],
          showStatementList: true,
          loadingStatement: false 
        });
        toast.error(response?.message || "Bad Request");
      }
    } catch (err) {
      console.error('Error fetching statement list:', err);
      toast.error('Failed to fetch statement list');
      this.setState({ loadingStatement: false, error: 'Failed to fetch statement list' });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.record?.bank_statement_match_id !== prevProps.record?.bank_statement_match_id) {
      this.setState({ selectedBankRecordId: this.props.record?.bank_statement_match_id || null });
    }
  }

  handleSelectRecord = (id) => {
    this.setState({ selectedBankRecordId: id });
    this.setState({selectedStatementIndex:-1})
  }

  handleMatchRecord = async () => {
    const { record } = this.props;
    const { selectedBankRecordId ,slectedStatementItem } = this.state;
    if (!selectedBankRecordId) {
      toast.warning('Please select a record to match');
      return;
    }

    this.setState({ loading: true, error: '' });
    try {
      console.log("slectedStatementItem JSP New----------====",slectedStatementItem);
      const response = await MasterService.editBankMatch(selectedBankRecordId, record.id ,slectedStatementItem || {});
      if (response) {
        // MasterService handles the success toast now
        if (this.props.onSuccess) this.props.onSuccess();
      }
    } catch (err) {
      console.error('Error matching record:', err);
      // MasterService handles the error toast now
    } finally {
      this.setState({ loading: false });
    }
  }

  handleDeleteMatch = async () => {
    const { record } = this.props;
    if (!window.confirm('Are you sure you want to delete this match?')) return;

    this.setState({ loading: true, error: '' });
    try {
      const response = await MasterService.deleteMatch(record.id, 'bank');
      if (response) {
        // MasterService handles the success toast now
        if (this.props.onSuccess) this.props.onSuccess();
      }
    } catch (err) {
      console.error('Error deleting match:', err);
      // MasterService handles the error toast
    } finally {
      this.setState({ loading_delete: false });
    }
  }

  formatCurrency = (amount) => {
    if (!amount) return 'N/A';
    return `Rp ${parseFloat(amount).toLocaleString('id-ID')}`;
  };

  formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); // DD/MM/YYYY
  };

  render() {
    const { record } = this.props;
    if (!record) return null;

    const { bank_statement_partial_matches = [], ocr_data = {}, bank_statement_system_match = {} } = record;
    // Filter matches based on search text
    const filteredMatches = bank_statement_partial_matches.filter(match =>
      match.name.toLowerCase().includes(this.state.searchText.toLowerCase())
    );
    const selectedPartialMatch = bank_statement_partial_matches.find(m => m.id === this.state.selectedBankRecordId);
    const selectedStatement = this.state.selectedStatementIndex !== null ? this.state.statementList[this.state.selectedStatementIndex] : null;
    const bankRecordToDisplay =  selectedStatement || (bank_statement_system_match?.id ? bank_statement_system_match : null);

console.log("selectedStatement===",selectedStatement);
console.log("selectedPartialMatch===",selectedPartialMatch);
console.log("bankRecordToDisplay===",bankRecordToDisplay);
    return (
      <React.Fragment>
        <div className='other-record-history-outer'>
          <div className='row'>
            <div className='col-md-6'>
              <span className='macth-data-heading'>Partial Match Records</span>
              <div className='other-record-history-list'>
                <div className='other-record-search-list'>
                  <ul>
                    {filteredMatches.map((match) => (
                      <li
                        key={match.id}
                        style={{
                          color:
                            this.state.selectedBankRecordId === match.id ? 'green' : 'inherit'
                        }}
                        onClick={!this.props.viewOnly ? () => this.handleSelectRecord(match.id) : undefined}
                        className={this.state.selectedBankRecordId === match.id ? 'active' : ''}
                      >
                        {match.name}
                        {this.state.selectedBankRecordId === match.id && (
                          <span>
                            <i className='ic-check'></i>
                          </span>
                        )}
                      </li>
                    ))}
                    {filteredMatches.length === 0 && <li className="text-center">No matching records found</li>}
                  </ul>
                </div>
              </div>
              {this.state.error && <p className="text-danger m-sm-t">{this.state.error}</p>}

              <div className='bank-record-date-filter m-sm-t' style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
                <div className='row'>
                  <div className='col-md-12'>
                    <span className='macth-data-heading'>Bank Record Date Filter</span>
                    <div className='date-filter-controls' style={{ marginTop: '10px' }}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="material">
                            <Calendra onChange={this.handleDateChange} value={this.state.filterDate}/>
                            <label className="form-label" style={{ top: '-20px', fontSize: '12px' }}>Filter Date</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <button
                            className='btn-primary'
                            onClick={this.handleStatementListSearch}
                            disabled={this.state.loadingStatement}
                            style={{ marginTop: '5px', minWidth: '180px' }}
                          >
                            {this.state.loadingStatement ? 'Searching...' : 'Search Statement List'}
                          </button>
                        </div>


                    

                      </div>

                      <div className='bank-statement-search-list'>
                        {/* Statement Search Box */}
                        { !this.props.viewOnly && this.state.statementList.length > 0 ? (
                          <fieldset className="search-bx m-sm-b">
                            <div className="material">
                              <input
                                type="text"
                                placeholder="Search by Statement Details"
                                className="form-input"
                                value={this.state.statementSearchText}
                                onChange={this.handleStatementSearchChange}
                              />
                              <i className="ic-search"></i>
                            </div>
                          </fieldset>
                        ) : null}
                        
                        <div className='other-record-search-list'>
                          <ul>
                            {this.state.statementList
                              .filter(statement => {
                                if (!this.state.statementSearchText) return true;
                                const searchLower = this.state.statementSearchText.toLowerCase();
                                return (
                                  (statement.description && statement.description.toLowerCase().includes(searchLower)) ||
                                  (statement.account_number && statement.account_number.toLowerCase().includes(searchLower)) ||
                                  (statement.amount && statement.amount.toString().toLowerCase().includes(searchLower))
                                );
                              })
                              .map((statement, index) => (
                                <li
                                  key={index}
                                  style={{
                                    color:
                                      this.state.selectedStatementIndex === index ? 'green' : 'inherit'
                                  }}
                                  onClick={!this.props.viewOnly ? () => this.handleSelectStatement(statement, index) : undefined}
                                  className={this.state.selectedStatementIndex === index ? 'active' : ''}
                                >
                                  {statement.description || `Statement #${index + 1}`}
                                  {this.state.selectedStatementIndex === index && (
                                    <span>
                                      <i className='ic-check'></i>
                                    </span>
                                  )}
                                </li>
                              ))}
                            {this.state.statementList.filter(statement => {
                              if (!this.state.statementSearchText) return true;
                              const searchLower = this.state.statementSearchText.toLowerCase();
                              return (
                                (statement.description && statement.description.toLowerCase().includes(searchLower)) ||
                                (statement.account_number && statement.account_number.toLowerCase().includes(searchLower)) ||
                                (statement.amount && statement.amount.toString().toLowerCase().includes(searchLower))
                              );
                            }).length === 0 && (
                              <li className="text-center">No matching statements found</li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!this.props.viewOnly && (
                <div className='match-btn-botton'>
                  <button
                    className='btn-primary'
                    onClick={this.handleMatchRecord}
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? 'Processing...' : 'Match Record'}
                  </button>
                  <button
                    className='btn-line m-sm-l'
                    onClick={this.handleDeleteMatch}
                    disabled={record.bank_match_status === '4' ? true : false}
                  >  
                   {this.state.loading_delete ? 'deleting...' : 'Delete Match'}
                  </button>
                </div>
              )}
            </div>
            <div className='col-md-6'>
              <div className='bank-recording-match-data'>
                <div className='row'>
                  <div className='col-md-12'>
                    <span className='macth-data-heading'>Matching Details</span>
                    <div className='matching-detail-list'>
                      <table>
                        <thead>
                          <tr>
                            <th>Criteria</th>
                            <th>Bank Record</th>
                            <th>Dealer Record</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Date</td>
                            <td>{this.formatDate(bankRecordToDisplay?.statement_date || selectedPartialMatch?.statement_date)}</td>
                            <td>{this.formatDate(ocr_data.ocrDate)}</td>
                          </tr>
                          <tr>
                            <td>Amount</td>
                            <td>{this.formatCurrency(bankRecordToDisplay?.amount || selectedPartialMatch?.amount)}</td>
                            <td>{this.formatCurrency(ocr_data.ocrAmount)}</td>
                          </tr>
                          <tr>
                            <td>Remark</td>
                            <td>{selectedPartialMatch?.name || selectedStatement?.description || bankRecordToDisplay?.name || 'N/A'}</td>
                            <td>{ocr_data.ocrRemark || 'N/A'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className='col-md-12 p-lg-t'>
                    <span className='macth-data-heading'>Upload Proof</span>
                    <div className='dealer-prof-outer'>
                      <img src={record.upload_proof_url || DealerProff} alt='Upload Proof' style={{ maxWidth: '100%' }} />
                    </div>
                  </div>
          
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default BankMatchRecordPopupList;